import { useNavigate, useLocation } from 'react-router-dom';
import { FeatureLabsPage } from './feature-labs';
import { SettingsLayout } from '@/components/Pages/SettingsLayout';

export default function SettingsFeatureLabsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <SettingsLayout currentPath={location.pathname} onNavigate={navigate}>
      <div className="h-full overflow-auto p-6">
        <FeatureLabsPage showHeader={false} />
      </div>
    </SettingsLayout>
  );
}
